import { useState } from "react";
import { api, formatApiError } from "../../lib/api";
import { toast } from "sonner";

export function useChatUpload(channel) {
  const [pending, setPending] = useState([]);
  const [uploading, setUploading] = useState(false);

  const upload = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    if (!files.length) return;
    setUploading(true);
    try {
      for (const f of files) {
        const fd = new FormData();
        fd.append("file", f);
        const { data } = await api.post(`/chat/upload?channel=${encodeURIComponent(channel)}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
        setPending((p) => [...p, data]);
      }
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setUploading(false); }
  };

  const removePending = (id) => setPending((p) => p.filter((x) => x.id !== id));
  const clearPending = () => setPending([]);

  return { pending, uploading, upload, removePending, clearPending };
}
